import { render, staticRenderFns } from "./VisitorDocumentsFormBlock.vue?vue&type=template&id=610bdec8"
import script from "./VisitorDocumentsFormBlock.vue?vue&type=script&lang=js"
export * from "./VisitorDocumentsFormBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports